// extracted by mini-css-extract-plugin
module.exports = {"BestSellers":"BestSellers_BestSellers__uRBkk"};